import DatePicker from 'vue2-datepicker';
import Vue from 'vue';

Vue.use(DatePicker);

const Base = Vue.options.components['DatePicker'];
const CustomDatePicker = Base.extend({
  methods: {
    // Overwrite the existing method 'emitValue' cause close event not working properly
    emitValue(date, type) {
      // fix IE11/10 trigger input event when input is focused. (placeholder !== '')
      this.userInput = null;
      var value = Array.isArray(date) ? date.map(this.date2value) : this.date2value(date);
      this.$emit('input', value);
      this.$emit('change', value, type);
      // this.afterEmitValue(type);
      return value;
    },
  },
});

Vue.component('CustomDatePicker', CustomDatePicker);